import { Link } from "react-router-dom";
import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { getProductsListing, getuserProductsListing, delProduct } from "../../redux/actions";
import { useEffect, useState } from "react";
import { Modal, } from "reactstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import axios from "axios";
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { TableHead, TableRow, TableCell, Table, TableBody, TableSortLabel, TablePagination, makeStyles, useScrollTrigger } from "@material-ui/core";
import { getCategory, getSubcategory } from "../../redux/actions";
import { FacebookShareButton, FacebookIcon } from "react-share";


const AdminListing = () => {


    const dispatch = useDispatch();
    let user = useSelector((state) => state.userDetails.user);
    const products = useSelector((state) => state.productDetails.listing);
    const products_size = useSelector((state) => state.productDetails.listingsize);
    const [shareModal, toggleShareModal] = useState(false);
    const [idList, setIdList] = useState([]);
    const category = useSelector((state) => state.categoryDetail.categories);
    const subcategory = useSelector((state) => state.subCategoryDetail.subCategories);
    const [search, setsearch] = useState("");
    const [searchflag, setsearchflag] = useState(false);
    const [shareUrl, setShareUrl] = useState("");
    const [shareCode, setSharedCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [color, setColor] = useState("#000000");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(15);
    const [skip, setskip] = React.useState(0)
    const [trigger, setTrigger] = React.useState(1)
    const [getDelClass, setDelClass] = useState('hideModal');
    const [getMultiDelClass, setMultiDelClass] = useState('hideModal');
    const [delLoading, setdelLoading] = useState(false)
    const [delDisable, setDelDisable] = useState(false)
    const [delcolor, setdelColor] = useState("#FF7E06")
    const [getDelId, setDelId] = useState();
    const [reset, setReset] = useState(false);

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    window.onmousedown = (e) => {
        const modals = document.getElementsByClassName("modal viewModal");
        // console.log("clicked!!! => ", e.target);
        // console.log("modal => ", modals[0]);
        if (modals[0] === e.target) {
            if (getDelClass === 'viewModal')
                setDelClass('hideModal')
            else if (getMultiDelClass === 'viewModal')
                setMultiDelClass('hideModal')
        }
    }

    useEffect(() => {
        dispatch(getCategory());
        dispatch(getSubcategory())
    }, [])


    useEffect(() => {
        // alert('yes triggering')
        setLoading(true);
        const callback = () => {
            setLoading(false);
            setReset(false);
        }
        if (user.role[0] == "admin") {
            dispatch(getProductsListing({ skip: skip, limit: rowsPerPage, searchWords: search, searchflag: searchflag, callback }));
        }
        else if (user.role[0] == "user") {
            dispatch(getuserProductsListing({ skip: skip, limit: rowsPerPage, searchWords: search, searchflag: searchflag, callback }));
        }

    }, [skip, rowsPerPage, page, trigger])

    useEffect(() => {
        if (search !== "") {
            setsearchflag(true)
        }
        else if (search === "") {
            setsearchflag(false)
        }
    }, [search])

    useEffect(() => {
        if (reset) {
            setsearch("");
        }
    }, [reset])

    useEffect(() => {
        if (reset && searchflag === false) {
            // console.log("INSIDE RESET & SEARCH FLAG", searchflag);
            onChangeSearch();
        }
    }, [searchflag])

    useEffect(() => {
        const filteredProducts = products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase()));
        if (idList.length ? idList.length === products.length || idList.length === filteredProducts.length : false) {
            const checkAllInput = document.getElementById("checkAllInput");
            if (!checkAllInput.checked)
                checkAllInput.checked = true;
        }
    }, [idList])

    useEffect(() => {
        setdata({ ...products, rows: sortedItems })
        setDelClass('hideModal');
        setMultiDelClass('hideModal');
        setdelLoading(false)
        setDelDisable(false)
    }, [products])

    const onChangeSearch = () => {
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
        setPage(0);
        setskip(0);
        setRowsPerPage(rowsPerPage)
        // if (search !== "") {
        //     setsearchflag(true)
        // }
        // else if (search == "") {
        //     setsearchflag(false)
        // }
        const new_trg = trigger + 1
        setTrigger(new_trg)
    }

    const delList = (check, id) => {
        if (check) {
            // const ifsub = useSelector((state) => state.productDetails.listing.find((cat)));
            // setCategoryProductAssocClass('viewModal')
            setDelClass('viewModal')
            setDelId(id)
        }
    }

    const handleChangePage = (event, newPage) => {

        const upcoming_result = ((newPage + 1) * rowsPerPage) - rowsPerPage;
        setskip(upcoming_result)
        setPage(newPage);
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
        setskip(0);
        const new_trg = trigger + 1
        setTrigger(new_trg)
    };


    const toggle = () => {
        toggleShareModal(!shareModal);
    };


    const deleteProduct = async (id) => {

        try {

            const response = await axios.request({
                data: { idList: [id] },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'post',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/delete-product`
            })

            const idList = [id];

            if (response.data.success) {
                dispatch(delProduct({ idList }));
                const callback = () => {
                    setLoading(false);
                }
                if (user.role[0] == "admin") {
                    dispatch(getProductsListing({ skip: skip, limit: rowsPerPage, searchWords: search, searchflag: searchflag, callback }));
                }
                else if (user.role[0] == "user") {
                    dispatch(getuserProductsListing({ skip: skip, limit: rowsPerPage, searchWords: search, searchflag: searchflag, callback }));
                }

                toast.success(response.data.message);
                // setDelClass('hideModal');
            }
            // setdelLoading(false)
            // setDelDisable(false)

        }
        catch (error) {
            toast.success(error)
            // setdelLoading(false)
            // setDelDisable(false)
        }

    }

    const deleteMultiProducts = async () => {
        try {
            const response = await axios.request({
                data: { idList },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'post',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/delete-product`
            })

            if (response.data.success) {

                dispatch(delProduct({ idList }));
                const callback = () => {
                    setLoading(false);
                }
                if (user.role[0] == "admin") {
                    dispatch(getProductsListing({
                        skip: skip, limit: rowsPerPage, callback
                    }));
                }
                else if (user.role[0] == "user") {
                    dispatch(getuserProductsListing({
                        skip: skip, limit: rowsPerPage, callback
                    }));
                }

                toast.success(response.data.message);
                setIdList([]);
                const checkAllInput = document.getElementById("checkAllInput");
                if (checkAllInput.checked)
                    checkAllInput.checked = false;
                const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                for (let checkBox of checkBoxes1) {
                    if (checkBox.checked)
                        checkBox.checked = false;
                }
                // setMultiDelClass('hideModal');
            }
            // setdelLoading(false)
            // setDelDisable(false)
        }
        catch (error) {
            toast.error(error)
            // setdelLoading(false)
            // setDelDisable(false)
            // callback()
        }
    }

    var defaultSortBy = "createdAt";
    var defaultSortOrder = "desc";
    let [sortBy, setsortBy] = useState(defaultSortBy)             // default sort column
    let [sortOrder, setsortOrder] = useState(defaultSortOrder)    // default sort order

    const sortData = (sortBy, sortOrder, rows) => {
        var itemsToSort = JSON.parse(JSON.stringify(rows || products));
        var sortedItems = [];
        var compareFn = null;
        switch (sortBy) {
            case "createdAt":
                compareFn = (i, j) => {

                    if (i.createdAt < j.createdAt) {
                        return sortOrder === "desc" ? 1 : -1;
                    } else {
                        if (i.createdAt > j.createdAt) {
                            return sortOrder === "desc" ? -1 : 1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "title":
                compareFn = (i, j) => {

                    if (i.title < j.title) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.title > j.title) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "category":
                compareFn = (i, j) => {

                    if (i.title < j.title) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.title > j.title) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }

                };
                break;
            case "subcategory":
                compareFn = (i, j) => {
                    if (i.title < j.title) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.title > j.title) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;

            case "price":
                compareFn = (i, j) => {
                    if (parseFloat(i.buyNowPrice) < parseFloat(j.buyNowPrice)) {

                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (parseFloat(i.buyNowPrice) > parseFloat(j.buyNowPrice)) {

                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;

            case "minimumoffer":
                compareFn = (i, j) => {
                    if (parseFloat(i.minimumOfferPrice) < parseFloat(j.minimumOfferPrice)) {

                        return sortOrder === "asc" ? -1 : 1;
                    }
                    else {
                        if (parseFloat(i.minimumOfferPrice) > parseFloat(j.minimumOfferPrice)) {

                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;


            case "totaloffer":
                compareFn = (i, j) => {
                    if (parseInt(i.productBidders.length) < parseInt(j.productBidders.length)) {
                        return sortOrder === "asc" ? -1 : 1;
                    }
                    else {
                        if (parseInt(i.productBidders.length) > parseInt(j.productBidders.length)) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;

            default:
                break;
        }
        // console.log(`---->itemtosort${sortBy}`, itemsToSort)
        sortedItems = products ? itemsToSort.sort(compareFn) : '';
        // console.log('---->sortItems', sortedItems)
        return sortedItems;
    }

    const requestSort = (pSortBy) => {

        var newsortBy = sortBy;
        var newsortOrder = sortOrder;

        // console.log('-->newsortBy', newsortBy)
        // console.log('-->newsortOrder', newsortOrder)
        // console.log('-->pSortBy', pSortBy)

        return event => {
            if (pSortBy === newsortBy) {
                newsortOrder = newsortOrder === "asc" ? "desc" : "asc";
            } else {
                newsortBy = pSortBy;
                newsortOrder = "asc";
            }

            var sortedItems = sortData(newsortBy, newsortOrder);
            setdata({ ...data, rows: sortedItems })
            setsortBy(newsortBy)
            setsortOrder(newsortOrder)
        };
    }

    var sortedItems = sortData(defaultSortBy, defaultSortOrder, products);
    const [data, setdata] = useState({ ...products, rows: sortedItems })

    return (
        <>
            <div className="dashContentHeader">
                <h5 className="dashHeading mb-0">My Listing</h5>
            </div>

            <div className="dashboardCardRow">
                <div className="input-group mb-4 search-menu">

                    <Link to={'/post-new-listing'}>   <button className="border-0 sub-button mr-12"> Post New Listing </button></Link>
                </div>

                <div className="input-group mb-4 search-menu">
                    <input type="text" className="form-control" onChange={(e) => { setsearch(e.target.value); }} onKeyDown={(e) => { if (e.keyCode === 13) { onChangeSearch() } }} value={search} placeholder="Search using Listing Name..." />

                    <button className="btn btn-custom-1 reset-button" onClick={() => setReset(true)}>
                        <i class="fa fa-refresh" aria-hidden="true"></i> Reset</button>
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </span>
                    </div>
                </div>

                {/* <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </span>
                    </div>
                    <button className="btn btn-custom" onClick={async () => { await setsearchflag(false); await setsearch(""); setTimeout(() => { onChangeSearch() }, 100) }}>
    <i class="fa fa-refresh" aria-hidden="true"></i> Reset</button>*/}

                <div className="listingTableRow">
                    <div className="listingTableHeader d-flex flex-wrap justify-content-between align-items-center pb-4 ">
                        <div className="custom-control custom-checkbox no-padding">
                            {/* <input type="checkbox" className="custom-control-input" id="checkAllInput" onChange={(event) => {

                                const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                                const checkBoxes2 = document.getElementsByClassName("custom-control-input group2");
                                if (event.target.checked) {
                                    for (let checkBox of checkBoxes1) {
                                        if (!checkBox.checked)
                                            checkBox.checked = true;
                                    }
                                    for (let checkBox of checkBoxes2) {
                                        if (!checkBox.checked)
                                            checkBox.checked = true;
                                    }
                                    let tempArray = [];
                                    if (!searchflag) {
                                        products.forEach(product => {
                                            tempArray.push(product._id);
                                        })
                                    }
                                    else {
                                        const filteredProducts = products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase()));
                                        filteredProducts.forEach(product => {
                                            tempArray.push(product._id);
                                        })
                                    }
                                    setIdList(tempArray);
                                }
                                else {
                                    for (let checkBox of checkBoxes1) {
                                        if (checkBox.checked)
                                            checkBox.checked = false;
                                    }
                                    for (let checkBox of checkBoxes2) {
                                        if (checkBox.checked)
                                            checkBox.checked = false;
                                    }
                                    setIdList([]);
                                }

                            }} /> */}
                            {/* <label className="custom-control-label" for="checkAllInput">Showing {searchflag ? (products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase())).length) : (products && products.length)} products</label> */}
                            <label className="right-label-checkbox">Showing {searchflag ? (products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase())).length) : (products && products.length)} products
                                <input type="checkbox" className="custom-control-input" id="checkAllInput" onChange={(event) => {

                                    const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                                    if (event.target.checked) {
                                        for (let checkBox of checkBoxes1) {
                                            if (!checkBox.checked)
                                                checkBox.checked = true;
                                        }
                                        let tempArray = [];
                                        if (!searchflag) {
                                            products.forEach(product => {
                                                tempArray.push(product._id);
                                            })
                                        }
                                        else {
                                            const filteredProducts = products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase()));
                                            filteredProducts.forEach(product => {
                                                tempArray.push(product._id);
                                            })
                                        }
                                        setIdList(tempArray);
                                    }
                                    else {
                                        for (let checkBox of checkBoxes1) {
                                            if (checkBox.checked)
                                                checkBox.checked = false;
                                        }
                                        setIdList([]);
                                    }

                                }} />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <button className="border-0 deleteButton mr-md-4 mr-0" disabled={idList.length > 0 && getDelClass === "hideModal" && getMultiDelClass === "hideModal" ? false : true} style={idList.length === 0 ? { background: "grey" } : {}} onClick={() => setMultiDelClass('viewModal')}>
                                <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.33398 3.66667V2.33333C3.33398 1.97971 3.47446 1.64057 3.72451 1.39052C3.97456 1.14048 4.3137 1 4.66732 1H7.33398C7.68761 1 8.02674 1.14048 8.27679 1.39052C8.52684 1.64057 8.66732 1.97971 8.66732 2.33333V3.66667M10.6673 3.66667V13C10.6673 13.3536 10.5268 13.6928 10.2768 13.9428C10.0267 14.1929 9.68761 14.3333 9.33398 14.3333H2.66732C2.3137 14.3333 1.97456 14.1929 1.72451 13.9428C1.47446 13.6928 1.33398 13.3536 1.33398 13V3.66667H10.6673Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.66602 7V11" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.33398 7V11" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span className="mt-1">Delete</span>
                            </button>


                        </div>
                    </div>
                    <div className="table-responsive">

                        

                            <Table className="table customDashboardTable">

                                <TableHead>
                                    <TableRow>
                                        <TableCell id="sr">S.R.</TableCell>
                                        <TableCell> <TableSortLabel active={sortBy === "title"} direction={sortOrder} onClick={requestSort("title")}>Listing Name </TableSortLabel> </TableCell>
                                        <TableCell>  Category </TableCell>
                                        <TableCell> Subcategory </TableCell>
                                        <TableCell> <TableSortLabel active={sortBy === "price"} direction={sortOrder} onClick={requestSort("price")}     >Price </TableSortLabel></TableCell>
                                        <TableCell> <TableSortLabel active={sortBy === "minimumoffer"} direction={sortOrder} onClick={requestSort("minimumoffer")} >Minimum Offer Amount </TableSortLabel></TableCell>
                                        <TableCell> <TableSortLabel active={sortBy === "totaloffer"} direction={sortOrder} onClick={requestSort("totaloffer")} >No. of Offers </TableSortLabel></TableCell>
                                        <TableCell> Status </TableCell>
                                        <TableCell> Manage Bids </TableCell>
                                        <TableCell> Seller Info </TableCell>
                                        <TableCell className="action-col"> Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {loading &&
                                        (
                                            <TableRow >
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell className="action-col"><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>

                                            </TableRow>
                                        )}

                                    {!loading && data.rows && data.rows
                                        .map((product, index) => {
                                            const subcat = subcategory.find(cat => cat._id == product.subCategoryId);
                                            const cat = category.find(cat => cat._id == subcat.categoryId);
                                            return (
                                                <TableRow >
                                                    <TableCell>
                                                        {/* <div className="custom-control custom-checkbox">
                                                            <input type="checkbox" className="custom-control-input group1" id={`customCheck${index}`} onChange={(event) => {
                                                                if (event.target.checked) {
                                                                    setIdList([...idList, product._id]);
                                                                }
                                                                else {
                                                                    setIdList(idList.filter(id => id !== product._id));
                                                                    const checkAllInput = document.getElementById("checkAllInput");
                                                                    if (checkAllInput.checked)
                                                                        checkAllInput.checked = false;
                                                                }
                                                            }} />
                                                            <label className="custom-control-label" for={`customCheck${index}`}>{(page * rowsPerPage) + (index + 1)}</label>
                                                        </div> */}
                                                        <label className="right-label-checkbox orange">{(page * rowsPerPage) + (index + 1)}
                                                            <input type="checkbox" className="custom-control-input group1" id={`customCheck${index}`} onChange={(event) => {
                                                                if (event.target.checked) {
                                                                    setIdList([...idList, product._id]);
                                                                }
                                                                else {
                                                                    setIdList(idList.filter(id => id !== product._id));
                                                                    const checkAllInput = document.getElementById("checkAllInput");
                                                                    if (checkAllInput.checked)
                                                                        checkAllInput.checked = false;
                                                                }
                                                            }} />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </TableCell>
                                                    <TableCell>{product.title}</TableCell>
                                                    <TableCell>{cat.name}</TableCell>
                                                    <TableCell>{subcat.name}</TableCell>
                                                    <TableCell>{product.buyNowPrice}</TableCell>
                                                    <TableCell>{product.minimumOfferPrice}</TableCell>
                                                    <TableCell>{product.productBidders.length}</TableCell>
                                                    <TableCell><button className="btn soldBtn">{product.status}</button> </TableCell>
                                                    <TableCell>{product.offerManagementPage && <> <svg class="mr-2" width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.008 23.253H10.8129C10.7154 23.1555 -0.286879 20.2293 0.00573469 3.882V3.64791L1.50782 1.50208L1.80043 1.46307C1.9955 1.42405 11.008 0 11.008 0C11.008 0 20.0595 1.40454 20.2546 1.46307L20.4887 1.50208L21.9907 3.64791V3.882C22.1858 12.3483 19.2597 17.1666 16.7822 19.7026C14.0902 22.4727 11.2616 23.253 11.008 23.253ZM1.52732 4.17461C1.33225 18.103 9.66197 21.2632 11.0275 21.6924C12.432 21.2632 20.7032 18.0835 20.5277 4.11609L19.6108 2.80909C18.5964 2.575 14.5974 1.59962 11.047 1.50208C7.49663 1.59962 3.55611 2.575 2.48319 2.80909L1.52732 4.17461Z" fill="#01426A"></path><path d="M15.4373 10.1635H7.26367V11.7631H15.4373V10.1635Z" fill="#01426A"></path><path d="M15.4373 14.2015H7.26367V15.8011H15.4373V14.2015Z" fill="#01426A"></path><path d="M15.4373 6.12537H7.26367V7.72499H15.4373V6.12537Z" fill="#01426A"></path><path d="M7.22336 12.4068C6.44306 12.4068 5.7603 11.724 5.7603 10.9047C5.7603 10.1244 6.38454 9.40264 7.22336 9.40264H11.0664V8.29071H7.16484C5.70177 8.29071 4.58984 9.46116 4.58984 10.9242C4.58984 12.3873 5.7603 13.5577 7.16484 13.5577H11.0664V12.4068H7.22336Z" fill="#42C31D"></path></svg>
                                                        <a href={product.offerManagementPage} target="_blank" >Manage</a> </>}
                                                    </TableCell>
                                                    <TableCell>  {product.sellerName}    </TableCell>
                                                    <TableCell className="action-col">
                                                        {/* <div className="dropdown">
                                                        <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                                                <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                                                <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                                            </svg>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                            <Link className="dropdown-item" to={`/edit-post-new-listing/${product._id}`}>Edit</Link>
                                                            <button className="dropdown-item" onClick={() => { delList(true, product._id) }}>Delete</button>
                                                            <button className="dropdown-item" onClick={() => { toggleShareModal(true); setShareUrl(`${process.env.REACT_APP_URL}/product-details?productId=${product._id}`); setSharedCode(product.shareCode) }}>Share</button>
                                                        </div>
                                                    </div> */}
                                                        <ul className="action-list list-unstyled mb-0 d-flex align-items-center">
                                                            <li>
                                                                <Link to={`/edit-post-new-listing/${product._id}`} className="fa fa-pencil-square-o"></Link>
                                                            </li>
                                                            <li onClick={() => { delList(true, product._id) }}>
                                                                <i className="fa fa-trash"></i>
                                                            </li>
                                                            <li onClick={() => { toggleShareModal(true); setShareUrl(`${process.env.REACT_APP_URL}/product-details?productId=${product._id}`); setSharedCode(product.shareCode) }}>
                                                                <i className="fa fa-share-square-o"></i>
                                                            </li>
                                                        </ul>
                                                    </TableCell>
                                                </TableRow>)
                                        })}
                                </TableBody>
                            </Table>
                            <TablePagination rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]} component="div" count={products_size ? products_size : 0} rowsPerPage={rowsPerPage} page={page} onChangePage={handleChangePage} onChangeRowsPerPage={handleChangeRowsPerPage} />
                        
                    </div>
                </div>
            </div >

            {shareModal && (
                <Modal isOpen={shareModal} toggle={toggle}>
                    <div class="modal-body p-4">
                        {user.role[0] == "admin" && <> <h4 class="font-18 w-100 text-center mt-3">
                            <b>CODE</b>
                        </h4>
                            <div className="code">
                                <h4>{shareCode}</h4>
                                <CopyToClipboard
                                    text={shareCode}
                                    onCopy={() => {
                                        toast.success('Copied to clipboard');
                                    }}
                                >
                                    <p style={{ cursor: "pointer" }} class="mb-0"> Click to copy</p>
                                </CopyToClipboard>


                            </div>

                        </>}


                        <hr />
                        <div class="share-link mt-3 mb-4 text-center">
                            <p className="mt-4">Share Link</p>
                            <form class="link-text mt-4">
                                <input type="text" readOnly={true} value={shareUrl} />
                                <CopyToClipboard
                                    text={shareUrl}
                                    onCopy={() => {
                                        toast.success("Copied to clipboard");
                                    }}
                                >
                                    <button type="button">
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M16 20H8C7.20435 20 6.44129 19.6839 5.87868 19.1213C5.31607 18.5587 5 17.7956 5 17V7C5 6.73478 4.89464 6.48043 4.70711 6.29289C4.51957 6.10536 4.26522 6 4 6C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 18.3261 3.52678 19.5979 4.46447 20.5355C5.40215 21.4732 6.67392 22 8 22H16C16.2652 22 16.5196 21.8946 16.7071 21.7071C16.8946 21.5196 17 21.2652 17 21C17 20.7348 16.8946 20.4804 16.7071 20.2929C16.5196 20.1054 16.2652 20 16 20ZM21 8.94C20.9896 8.84813 20.9695 8.75763 20.94 8.67V8.58C20.8919 8.47718 20.8278 8.38267 20.75 8.3L14.75 2.3C14.6673 2.22222 14.5728 2.15808 14.47 2.11H14.38L14.06 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V15C7 15.7956 7.31607 16.5587 7.87868 17.1213C8.44129 17.6839 9.20435 18 10 18H18C18.7956 18 19.5587 17.6839 20.1213 17.1213C20.6839 16.5587 21 15.7956 21 15V9C21 9 21 9 21 8.94ZM15 5.41L17.59 8H16C15.7348 8 15.4804 7.89464 15.2929 7.70711C15.1054 7.51957 15 7.26522 15 7V5.41ZM19 15C19 15.2652 18.8946 15.5196 18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H10C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4H13V7C13 7.79565 13.3161 8.55871 13.8787 9.12132C14.4413 9.68393 15.2044 10 16 10H19V15Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </button>
                                </CopyToClipboard>


                            </form>
                            <FacebookShareButton
                                url={shareUrl}
                                quote={shareCode}
                                hashtag={"#livestock"}
                                description={`Here the share code to claimed the product:${shareCode}`}
                                className="Demo__some-network__share-button mt-4"
                            >
                                <FacebookIcon size={32} round /></FacebookShareButton>
                        </div>
                    </div>{" "}
                </Modal>
            )}

            <div id="delModal" className={`modal ${getDelClass}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header px-4">
                            <h5 className="modal-title">Delete List Item</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setDelClass('hideModal') }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-padding">
                            <div className="text-center d-flex flex-column delete-modal">
                                <div>
                                    <h6 className="text-uppercase">Are you sure you want to delete this item ?</h6>
                                </div>
                                <div>
                                    <button className="btn btn-custom mr-2" disabled={delDisable} onClick={() => { setDelClass('hideModal') }}>No</button>
                                    <button className="btn btn-custom" disabled={delDisable} onClick={() => { deleteProduct(getDelId); setdelLoading(true); setDelDisable(true) }} id="whiteBtn">
                                        {delLoading && <SyncLoader color={delcolor} loading={delLoading} css={override} size={11} />}
                                        {!delLoading && "Yes"}

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="multiDelModal" className={`modal ${getMultiDelClass}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header px-4">
                            <h5 className="modal-title">Delete Selected Items</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setMultiDelClass('hideModal') }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-padding">
                            <div className="text-center d-flex flex-column delete-modal">
                                <div>
                                    <h6 className="text-uppercase">Are you sure you want to delete these selected items ?</h6>
                                </div>
                                <div>
                                    <button className="btn btn-custom mr-2" disabled={delDisable} onClick={() => { setMultiDelClass('hideModal') }}>No</button>
                                    <button className="btn btn-custom" disabled={delDisable} onClick={() => { deleteMultiProducts(); setdelLoading(true); setDelDisable(true) }} id="whiteBtn">
                                        {delLoading && <SyncLoader color={delcolor} loading={delLoading} css={override} size={11} />}
                                        {!delLoading && "Yes"}

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminListing;